import cartApi from '@/api/cart';

export default [
    {
        path: '/dashboard',
        component: () => import(/* webpackChunkName: 'dashboard' */ '@/pages/dashboard/DashboardPage.vue'),
    },

    // QuickScan
    {
        path: '/quickscan',
        component: () => import(/* webpackChunkName: 'quickscan' */ '@/pages/quickscan/QuickScanPage.vue'),
        meta: { broadcastChannels: ['carts'] },
    },
    {
        path: '/quickscan/settings/tradeconditions',
        component: () => import(/* webpackChunkName: 'quickscan' */ '@/pages/quickscan/settings/TradeConditionsPage.vue'),
        meta: { showProgressBar: true },
    },
    {
        path: '/quickscan/settings/tradebans',
        component: () => import(/* webpackChunkName: 'quickscan' */ '@/pages/quickscan/settings/TradeBansPage.vue'),
        meta: { showProgressBar: true },
    },

    // Carts
    {
        path: '/carts',
        component: () => import(/* webpackChunkName: 'carts' */ '@/pages/carts/CartsPage.vue'),
        meta: { showProgressBar: true, broadcastChannels: ['carts'] },
    },
    {
        path: '/carts/find/:code',
        meta: { showProgressBar: true },
        beforeEnter: async (to, from, next) => {
            try {
                let cart = await cartApi.find(to.params.code);
                next(`/carts/${cart.id}`);
            } catch (e) {
                next('/carts');
            }
        }
    },
    {
        path: '/carts/stats',
        component: () => import(/* webpackChunkName: 'carts-stats' */ '@/pages/carts/stats/CartStatsPage.vue'),
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: 'carts-stats' */ '@/pages/carts/stats/CartTotals.vue'),
                meta: { menuItem: 'totals', showProgressBar: true },
            },
            {
                path: 'list',
                component: () => import(/* webpackChunkName: 'carts-stats' */ '@/pages/carts/stats/CartList.vue'),
            },
            {
                path: 'completionTimes',
                component: () => import(/* webpackChunkName: 'carts-stats' */ '@/pages/carts/stats/CartCompletionTimes.vue'),
                meta: { menuItem: 'completionTimes' },
            },
            {
                path: 'buyers',
                component: () => import(/* webpackChunkName: 'carts-stats' */ '@/pages/carts/stats/CartBuyers.vue'),
                meta: { menuItem: 'buyers' },
            },
            {
                path: 'quickScan',
                component: () => import(/* webpackChunkName: 'carts-stats' */ '@/pages/carts/stats/QuickScanSearches.vue'),
                meta: { menuItem: 'quickScan' },
            },
            {
                path: 'customerOrigins',
                component: () => import(/* webpackChunkName: 'carts-stats' */ '@/pages/carts/stats/CustomerOrigins.vue'),
                meta: { menuItem: 'customerOrigins' },
            },
        ],
    },
    {
        path: '/carts/:cartId',
        component: () => import(/* webpackChunkName: 'carts' */ '@/pages/carts/CartPage.vue'),
        props: true,
        meta: { showProgressBar: true, broadcastChannels: ['carts'] },
    },

    // Wishlists
    {
        path: '/wishlists',
        component: () => import(/* webpackChunkName: 'wishlists' */ '@/pages/wishlists/WishlistItemsPage.vue'),
    },
    {
        path: '/wishlists/items/:wishlistItemId',
        component: () => import(/* webpackChunkName: 'wishlists' */ '@/pages/wishlists/WishlistItemPage.vue'),
        props: true,
        meta: { broadcastChannels: ['textMessages'] },
    },
    {
        path: '/wishlists/stats',
        component: () => import(/* webpackChunkName: 'wishlists' */ '@/pages/wishlists/StatsPage.vue'),
    },


    // Customers
    {
        path: '/customers',
        component: () => import(/* webpackChunkName: 'customers' */ '@/pages/customers/CustomersPage.vue'),
        meta: { showProgressBar: true, broadcastChannels: ['textMessages', 'carts'] },
    },
    {
        path: '/customers/:customerId',
        component: () => import(/* webpackChunkName: 'customers' */ '@/pages/customers/CustomerPage.vue'),
        props: true,
        meta: { showProgressBar: true, broadcastChannels: ['textMessages', 'carts'] },
    },

    // Inventory
    {
        path: '/inventoryitems',
        component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/vendors/VendorInventoryPage.vue'),
        props: true,
    },

    // Vendors
    {
        path: '/vendors',
        component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/vendors/VendorsPage.vue'),
        meta: { showProgressBar: true },
    },
    {
        path: '/vendors/:id',
        component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/vendors/VendorPage.vue'),
        props: true,
        meta: { showProgressBar: true },
        redirect: '/vendors/:id/inventories',
        children: [
            {
                path: 'inventories',
                name: 'vendors.show.inventories',
                component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/vendors/VendorInventoriesPage.vue'),
            },
            {
                path: 'inventorycategories',
                name: 'vendors.show.inventorycategories',
                component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/vendors/VendorInventoryCategoriesPage.vue'),
            },
            {
                path: 'inventorysources',
                name: 'vendors.show.inventorysources',
                component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/vendors/VendorInventorySourcesPage.vue'),
            },
            {
                path: 'refreshoperations',
                name: 'vendors.show.refreshoperations',
                component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/vendors/VendorRefreshOperationsPage.vue'),
                meta: { broadcastChannels: ['refreshOperations'] },
            },
            {
                path: 'orders',
                name: 'vendors.show.orders',
                component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/vendors/VendorOrdersPage.vue'),
            },
        ],
    },
    {
        path: '/vendors/:vendorId/inventory',
        component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/vendors/VendorInventoryPage.vue'),
        props: true,
    },

    // Refresh Operations
    {
        path: '/refreshoperations/:id',
        component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/refreshOperations/RefreshOperationPage.vue'),
        props: true,
        meta: { broadcastChannels: ['refreshOperations'] },
    },

    // Inventories
    {
        path: '/inventories',
        component: () => import(/* webpackChunkName: 'inventories' */ '@/pages/inventories/InventoriesPage.vue'),
        meta: { showProgressBar: true },
    },
    {
        path: '/inventories/:id',
        component: () => import(/* webpackChunkName: 'inventories' */ '@/pages/inventories/InventoryPage.vue'),
        props: true,
        redirect: '/inventories/:id/info',
        children: [
            {
                path: 'info',
                name: 'inventories.show.info',
                component: () => import(/* webpackChunkName: 'inventories' */ '@/pages/inventories/InventoryInfoPage.vue'),
            },
            {
                path: 'refreshoperations',
                name: 'inventories.show.refreshoperations',
                component: () => import(/* webpackChunkName: 'inventories' */ '@/pages/inventories/InventoryRefreshOperationsPage.vue'),
                meta: { broadcastChannels: ['refreshOperations'] },
            },
            {
                path: 'items',
                name: 'inventories.show.items',
                component: () => import(/* webpackChunkName: 'inventories' */ '@/pages/inventories/InventoryInventoryItemsPage.vue'),
            },
        ]
    },

    // Product Bans
    {
        path: '/productbans',
        component: () => import(/* webpackChunkName: 'vendors' */ '@/pages/productbans/ProductBansPage.vue'),
    },

    // Orders
    {
        path: '/orders/:orderId',
        component: () => import(/* webpackChunkName: 'orders' */ '@/pages/orders/OrderPage.vue'),
        props: true,
    },

    // Watch Lists
    {
        path: '/watchLists',
        component: () => import(/* webpackChunkName: 'watchLists' */ '@/pages/watchLists/WatchListsPage.vue'),
        meta: { showProgressBar: true },
    },
    {
        path: '/watchLists/:watchListId',
        component: () => import(/* webpackChunkName: 'watchLists' */ '@/pages/watchLists/WatchListPage.vue'),
        props: true,
        meta: { },
    },

    // Filters
    {
        path: '/filters',
        name: 'filters.index',
        component: () => import(/* webpackChunkName: 'filters' */ '@/pages/filters/FiltersPage.vue'),
    },
    {
        path: '/filters/create',
        name: 'filters.create',
        component: () => import(/* webpackChunkName: 'filters' */ '@/pages/filters/FilterEditPage.vue'),
    },
    {
        path: '/filters/:id/edit',
        name: 'filters.edit',
        component: () => import(/* webpackChunkName: 'filters' */ '@/pages/filters/FilterEditPage.vue'),
        props: true,
    },

    // Site Notifications
    {
        path: '/siteNotifications',
        component: () => import(/* webpackChunkName: 'admin' */ '@/pages/siteNotifications/SiteNotificationsPage.vue'),
        meta: { showProgressBar: true },
    },

    // System Console
    {
        path: '/systemconsole',
        component: () => import(/* webpackChunkName: 'admin' */ '@/pages/systemconsole/SystemConsolePage.vue'),
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: 'admin' */ '@/pages/systemconsole/BasicInfoPage.vue'),
                meta: { menuItem: 'info' },
            },
            {
                path: 'mail',
                component: () => import(/* webpackChunkName: 'admin' */ '@/pages/systemconsole/MailPage.vue'),
                meta: { menuItem: 'mail', showProgressBar: true, broadcastChannels: ['mail'] },
            },
            {
                path: 'mail/:mailMessageId',
                component: () => import(/* webpackChunkName: 'admin' */ '@/pages/systemconsole/MailMessagePage.vue'),
                props: true,
                meta: { menuItem: 'mail', showProgressBar: true, broadcastChannels: ['mail'] },
            },
            {
                path: 'textMessages',
                component: () => import(/* webpackChunkName: 'admin' */ '@/pages/systemconsole/TextMessagesPage.vue'),
                meta: { menuItem: 'textMessages', broadcastChannels: ['textMessages'] },
            },
            {
                path: 'refreshoperations',
                component: () => import(/* webpackChunkName: 'admin' */ '@/pages/systemconsole/RefreshOperationsPage.vue'),
                meta: { broadcastChannels: ['refreshOperations'] },
            },
        ],
    }
];
